import { UserRole } from '../models/user';

const authenticate = (allowedTypes: UserRole[], userRole: UserRole) => (userRole === 'ROOT' || allowedTypes.includes(userRole));

export default authenticate;
